import { PublicMarketingDetailPage } from "@/pages/public/marketing/marketing-detail";

export function UpdateDetailPage() {
  return <PublicMarketingDetailPage categoryPath="updates" />;
}

